/** A plain basket outline for the bottom nav. Decorative; the nav label carries the name. */
export function ShoppingIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      aria-hidden="true"
      className={className}
    >
      <path d="M3.5 9h17l-1.6 9.2a2 2 0 0 1-2 1.8H7.1a2 2 0 0 1-2-1.8z" strokeLinejoin="round" />
      <path d="M8 9l3-5M16 9l-3-5" strokeLinecap="round" />
      <path d="M9.5 13v3M14.5 13v3" strokeLinecap="round" />
    </svg>
  );
}
